/**
 * Groups dashboard product items by the selected group-by option.
 * Unlike the favourites groupBy, products here are direct objects (not wrapped in productResponse).
 */
const getDashboardGroupKey = (item, groupBy) => {
	const keyMap = {
		REQUEST_WISE: () => {
			const requestId = item?.inHouseDevelopmentJourneyDetails?.requestId;
			const brandName = item?.inHouseDevelopmentJourneyDetails?.brandResponse?.name;
			const systemReferenceNumber = item?.systemReferenceNumber;
			const collectionName = item?.collectionName;
			const requestTitle = [brandName, systemReferenceNumber, collectionName]
				.map((value) => (value != null ? String(value).trim() : ''))
				.filter(Boolean)
				.join(' | ');
			if (requestId != null && String(requestId).trim() !== '') {
				return requestTitle || 'No request';
			}
		},

		REQUEST_PRIORITY: () => {
			const priority = item?.taskPriority;
			if (priority === 'HIGH') return 'High';
			if (priority === 'STANDARD') return 'Standard';
			if (priority === 'EXPRESS') return 'Express';
			return 'Others';
		},

		MARKET_AND_CATEGORY: () => {
			const market = item?.productGroup || 'No Market';
			const category = item?.name || 'No Category';
			return `${market} - ${category}`;
		},

		MARKET_AND_FABRIC: () => {
			const market = item?.productGroup || 'No Market';
			const fabric = item?.mainFabricType || 'No Fabric';
			return `${market} - ${fabric}`;
		},

		COLLECTION: () => {
			return item?.collectionName || 'No Collection';
		},

		RECEIVED_BY_PD_DATE: () => {
			const d = item?.inHouseDevelopmentJourneyDetails?.pdReceivedDate;
			return d != null && String(d).trim() !== '' ? String(d).trim() : 'No Received Date';
		},

		SEND_TO_PD_DATE: () => {
			const d = item?.inHouseDevelopmentJourneyDetails?.sendToPdDate;
			return d != null && String(d).trim() !== '' ? String(d).trim() : 'No Send to PD date';
		}
	};

	return keyMap[groupBy] ? keyMap[groupBy]() : null;
};

export const dashboardGroupBy = (data, selectedGroupBy) => {
	if (!selectedGroupBy) return null;

	return data.reduce((acc, item) => {
		const key = getDashboardGroupKey(item, selectedGroupBy);
		if (key) {
			acc[key] = acc[key] || [];
			acc[key].push(item);
		}
		return acc;
	}, {});
};

export const Task_PRIORITY_OPTIONS = [
	{ id: 1, name: 'Standard', value: 'STANDARD' },
	{ id: 2, name: 'High', value: 'HIGH' },
	{ id: 3, name: 'Express', value: 'EXPRESS' }
];
